import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M2.532 12.5h7.171m-7.17 0V4.435c0-1.068.917-1.935 2.048-1.935h3.073c1.132 0 2.05.867 2.05 1.935v.807M2.531 12.5H1.167m8.536 0V5.242m0 7.258h4.098M9.703 5.242h2.049c1.131 0 2.049.866 2.049 1.935V12.5m0 0h1.366M6.972 5.726H5.264m0 2.58h1.707"
	})
});
export default SvgBuilding;
